function toCharCodeArray(chs: string) {
  var chArr = new Array(chs.length)
  for (var i = 0; i < chs.length; i++) {
    chArr[i] = chs.charCodeAt(i)
  }
  return chArr
}

export default class Hex {
  static encode(b: number[], pos: number, len: number) {
    var hexCh = new Array(len * 2)
    var hexCode = new Array(
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f'
    )

    for (var i = pos, j = 0; i < len + pos; i++, j++) {
      hexCh[j] = hexCode[(b[i] & 0xff) >> 4]
      hexCh[++j] = hexCode[b[i] & 0x0f]
    }

    return hexCh.join('')
  }

  static decode(hex: string) {
    if (hex == null || hex == '') {
      throw new Error('invalid hex string')
    }
    if (hex.length % 2 != 0) {
      throw new Error('invalid hex string')
    }

    var ascLen = hex.length / 2
    var hexCh = toCharCodeArray(hex)
    var asc = new Array(ascLen)

    for (var i = 0; i < ascLen; i++) {
      if (hexCh[2 * i] >= 0x30 && hexCh[2 * i] <= 0x39) {
        asc[i] = (hexCh[2 * i] - 0x30) << 4
      } else if (hexCh[2 * i] >= 0x41 && hexCh[2 * i] <= 0x46) {
        //A-F : 0x41-0x46
        asc[i] = (hexCh[2 * i] - 0x41 + 10) << 4
      } else if (hexCh[2 * i] >= 0x61 && hexCh[2 * i] <= 0x66) {
        //a-f  : 0x61-0x66
        asc[i] = (hexCh[2 * i] - 0x61 + 10) << 4
      } else {
        throw new Error('invalid hex string')
      }

      if (hexCh[2 * i + 1] >= 0x30 && hexCh[2 * i + 1] <= 0x39) {
        asc[i] = asc[i] | (hexCh[2 * i + 1] - 0x30)
      } else if (hexCh[2 * i + 1] >= 0x41 && hexCh[2 * i + 1] <= 0x46) {
        asc[i] = asc[i] | (hexCh[2 * i + 1] - 0x41 + 10)
      } else if (hexCh[2 * i + 1] >= 0x61 && hexCh[2 * i + 1] <= 0x66) {
        asc[i] = asc[i] | (hexCh[2 * i + 1] - 0x61 + 10)
      } else {
        throw new Error('invalid hex string')
      }
    }

    return asc
  }

  // utf8StrToHex(utf8Str: string) {
  //   var ens = encodeURIComponent(utf8Str);
  //   var es = unescape(ens);

  //   var esLen = es.length;

  //   // Convert
  //   var words = [];
  //   for (var i = 0; i < esLen; i++) {
  //     words[i] = es.charCodeAt(i).toString(16);
  //   }
  //   return words.join('');
  // }
  // utf8StrToBytes(utf8Str: string) {
  //   var ens = encodeURIComponent(utf8Str);
  //   var es = unescape(ens);

  //   var esLen = es.length;

  //   // Convert
  //   var words = [];
  //   for (var i = 0; i < esLen; i++) {
  //     words[i] = es.charCodeAt(i);
  //   }
  //   return words;
  // }

  // hexToUtf8Str(utf8Str: string) {
  //   var utf8Byte = this.decode(utf8Str);
  //   if (utf8Byte === null) {
  //     return '';
  //   }
  //   var latin1Chars = [];
  //   for (var i = 0; i < utf8Byte.length; i++) {
  //     latin1Chars.push(String.fromCharCode(utf8Byte[i]));
  //   }
  //   return decodeURIComponent(escape(latin1Chars.join('')));
  // }

  // bytesToUtf8Str(bytesArray: number[]) {
  //   var utf8Byte = bytesArray;
  //   var latin1Chars = [];
  //   for (var i = 0; i < utf8Byte.length; i++) {
  //     latin1Chars.push(String.fromCharCode(utf8Byte[i]));
  //   }
  //   return decodeURIComponent(escape(latin1Chars.join('')));
  // }
}
